import { PublicHeader } from "./PublicHeader";
import { PublicFooter } from "./PublicFooter";
import { Container, EmptyState } from "./kit";

export const PublicShell = ({ children, testid = "public-page", mainClassName = "" }) => (
  <div data-testid={testid} className="public-shell min-h-screen bg-white flex flex-col overflow-x-hidden">
    <PublicHeader />
    <main className={`flex-1 ${mainClassName}`}>{children}</main>
    <PublicFooter />
  </div>
);

// Interim page for routes that are built in a later phase — clean, never broken.
export const PublicStub = ({ title, sub }) => (
  <PublicShell testid="public-stub">
    <Container className="py-20">
      <EmptyState title={title} sub={sub || "This part of the new Brivio website is being polished and will be available shortly."} />
    </Container>
  </PublicShell>
);
